var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_185772",
    "data-name": "Group 185772",
    transform: "translate(-627 -568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_182383",
    "data-name": "Group 182383"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_149782",
    "data-name": "Rectangle 149782",
    width: 24,
    height: 24,
    transform: "translate(627 568)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_182380",
    "data-name": "Group 182380",
    transform: "translate(-14.552 1.152)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49750",
    "data-name": "Path 49750",
    d: "M8.911-1.465h5.641V1.219H8.911V6.848H6.164V1.219H.552V-1.465H6.164V-7.152H8.911Z",
    transform: "translate(646 579)",
    fill: "#676767"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusIcon);
export default __webpack_public_path__ + "static/media/plus_icon.0f39896ead28b762b85bba2fd9056f24.svg";
export { ForwardRef as ReactComponent };